import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { FontAlign } from '../../elements/resource/types/shape.type';

@Component({
  selector: 'nw-text-edit-modal',
  templateUrl: './text-edit-modal.component.html',
  styleUrls: ['./text-edit-modal.component.scss'],
})
export class TextEditModalComponent implements AfterViewInit {
  @Input() title = 'Edit Text';
  @Input() label = 'Text';
  @Input() value = '';
  @Input() placeholder = 'Enter text...';
  @Input() multiline = true;
  @Input() rows = 4;

  // Context
  @Input() id?: string; // optional cell id for downstream handlers

  // New fields for editing TextConfig
  @Input() fontSize?: number;
  @Input() widthRatio?: number;
  @Input() fontAlign?: FontAlign;

  @Output() cancel = new EventEmitter<void>();
  // Keep existing save event (string) for backward compatibility
  @Output() save = new EventEmitter<string>();
  // New event that emits full payload including textConfig changes
  @Output() saveFull = new EventEmitter<{
    id?: string;
    text: string;
    textConfig: { fontSize?: number; widthRatio?: number; align?: FontAlign };
  }>();

  @ViewChild('textInput') textInput: ElementRef;

  localValue = '';
  localFontSize?: number;
  localWidthRatio?: number;
  localFontAlign?: FontAlign;

  ngAfterViewInit() {
    this.textInput.nativeElement.focus();
  }
  ngOnInit() {
    this.localValue = this.value;
    this.localFontSize = this.fontSize;
    this.localWidthRatio = this.widthRatio;
    this.localFontAlign = this.fontAlign;
  }
  onKeyup(event: KeyboardEvent) {
    if (event.key === 'Enter' && !event.shiftKey) {
      this.localValue = this.localValue.trim();
      this.onSave();
    }
  }

  onClose() {
    this.cancel.emit();
  }

  setFontAlign(align: FontAlign) {
    this.localFontAlign = align;
  }

  onSave() {
    // Emit text (legacy)
    this.save.emit(this.localValue);

    // Emit full payload to allow updating textConfig
    this.saveFull.emit({
      id: this.id,
      text: this.localValue,
      textConfig: {
        fontSize: this.localFontSize,
        widthRatio: this.localWidthRatio,
        align: this.localFontAlign,
      },
    });
  }
}
